

<template>
  <div id="cart" @touchstart.stop='nomove'>
	<buyPlan  ref="edit" />
	<plugin />
  <Tabbar msg="/cart" />
	<Alert v-if='AlertShow' :alertMsg="alertMsg"  />
	<GoodsShortage v-if='selloutShow' :goodsMsg='selloutMsg'  @selloutShowFN="getMsgFormSellout"/>
	
	<div class="orderbarpad" ></div>
		<div class="orderbar" >
		    <div class='allCheck' @click="allSlectHandle" style="width: 1.2rem;">
		            <div class='allChecked'  v-if='allSlect'>
		                  <img src='../assets/gou.png'></img>
		            </div>
		            <div class='allChecking'  v-else></div>
		            <div style="line-height: 0.44rem;">全选</div>
		    </div>
		    <div class="total">
		        <div v-if='totalPay==0' style='color:#9B9B9B;'>请选择橘袋</div>
		        <div v-else-if='totalPay>0' >合计<span style=';margin-left:0.05rem;'> ¥{{totalPay||"0"}}</span></div>
		        <div>保税区免费直邮</div>
		    </div>
		    <div class="payBtn"  v-if='!totalPay||totalPay==0' style='filter:grayscale(1);opacity:0.5;'>结算</div>

		    <div class="payBtn" id="yuyuexiadan"  @click='toCreateOrder' v-else-if='totalPay>0'>结算</div>  
		  
		</div> 


    <div v-for='item in cartList'>
                  <div class='cartListBox' :class='item.showDelete?"cartDel":""'  v-if='!item.del' :data-id='item.id'  @touchstart='handletouchstart'  @touchmove="handletouchmove(item.id)"  @touchend='handletouchend'  >
                        <div class='cartListdelBtn'  @click="handleDelCart(item.id)">
                        <img :src='delImg'></img>
                        删除</div>

                        <div class='cartListBoxLeft' @click='handleslect(item.id)'  v-if='!item.noSlect'>
                       
                                    <div class='selected' v-if='item.slect'>
                                        <img src='../assets/gou.png'></img>
                                    </div>
                                    <div class='selecting'  v-else></div>                
                        </div>
                        <div class='cartListBoxLeft' @click='handleslect(item.id)' v-else>
                              
                         
                                    <div class='selecting'  style='background-color:#ddd;opacity:0.5;filter:(1);' ></div>
                          
                        </div>
                        <div class='cartListBoxMid'>
                                <img :src='item.img' @click="toCartDetail(item.id)"></img>
                                  <div class='cartListBoxLab lab0' v-if='item.source==0'>自选方案</div>
                                  <div class='cartListBoxLab'  v-if='item.source==1'>报告方案</div>
                                  <div class='cartListBoxLab lab2'  v-if='item.source==2'>套餐</div>
                                  <div class='cartListBoxLab'  v-if='item.source==3'>好友报告</div>
                        </div>
                        <div class='cartListBoxRight'>
                              <div class='cartListBoxName' bindtap="toCartDetail" :data-cartid='item.id'>{{item.name}}</div>
                              <div class='cartListBoxPrice'>¥<span class='cartListBoxNowPrice'>{{item.totalPrice}}</span><span class='cartListBoxBeforePrice' v-if='item.totalPrice!=item.originalPrice'>¥{{item.originalPrice}}</span></div>
           
                              <div class='cartListBoxPlan' @click="changePlan(item.id)"  v-if='item.source!=2'>
                                  <span>{{item.plan_title}}</span>
                                  <img src='../assets/2@2x.png'></img>
                              </div>
                      
                              <div class='cartListBoxPlan2'  v-else>
                                  <div class='mealBtn' @click="cutMealNum(item.id,item.num)">

                                            <img src='../assets/jian.png' v-if="item.num>1"></img>
                                            <img src='../assets/jian2.png' v-else></img>
                                  </div>
                                  <div class='mealNumBox'>
                                  	<input type="number" :value="item.num||1" maxlength='2' @keyup.enter='changeMealNum' @blur.prevent='changeMealNum' :data-cartid='item.id' ></input></div>
                                  <div class='mealBtn'  @click="addMealNum(item.id,item.num)" >
                                               <img src='../assets/jia.png'></img>
                                  </div>
                              </div>
                        </div>
                        <div class='cartListBoxPlanBtn' @click="toCartDetail(item.id)" >查看方案
                              <img src='../assets/icon-next3.png'></img>
                        </div> 
                  </div>

                  <div  v-if='item.del' class='nullBox'  :class='item.nullShow ?"nullBox2":""' ></div>
            </div>

        
		<div class='noCart' v-if='cartList.length<1&&nullList'>
			<div class='noCartTitle'>什么都没有</div>
			<div class='noCartMsg'>你还没有任何橘袋哦~</div>
			<div class='app-btn app-btn--shadow' @click='toQuestions'>即刻定制</div>
		<!-- 	<div>自选产品</div> -->
		</div>
		
		<div class='cartListTxt'  v-if='cartList.length>0'>* 应跨境电商政策要求，每笔订单不能超过5000元</div>
		<div style='height:3rem;'></div>
      </div>
		

		



  </div>
</template>

<script>
import Tabbar from '@/components/tabbar.vue'
import GoodsShortage from '@/popup/goodsShortage.vue'
import plugin from '@/components/plugin.vue'
import Alert from '@/popup/Alert.vue'
import buyPlan from '@/components/buyPlan.vue'
export default {
  name: 'cart',
  components: {
		Tabbar,
		GoodsShortage,
		plugin,
		buyPlan,
		Alert
  },
  data() {
		return {
			cartList:[],
			allSlect:false,
			totalPay:0,
			selloutShow:false,
			selloutMsg:{},
			AlertShow:false,
			nullList:false,    //是否允许显示空列表
			startX:0,
			moveCartId:0,
			delImg:require("@/assets/icon-delete3.png"),
		}
    },
    computed: {
     
    },
    mounted() {

    },
    created:function(){
   		this.getCartList()
		// history.pushState(null, null, document.URL);
		//         window.addEventListener('popstate', function () {
		//             history.pushState(null, null, document.URL);
		//         });

		
  	},
    methods:{
      nomove(){},
    // 获取橘袋列表
	    getCartList(){
	    	let that  = this
	      this.axios({
	                  method: 'post',
	                  url:"Allcart/getCartList",
	                  data:{
	                     member_id:this.$store.state.member_id 
	                  }
	                }).then(res=>{
						
	                    let  _cartList = res.data.cart_list
	                    let _cart_list = []
	                  	for (let i = 0; i < _cartList.length;i++){

				          _cartList[i].totalPrice = Number(_cartList[i].total_price) * Number(_cartList[i].num)
				          _cartList[i].originalPrice = Number(_cartList[i].original_price) * Number(_cartList[i].num)
				          _cartList[i].slect = false
				          
				          if (_cartList[i].source==0){   //自选放在第一个
				            _cart_list.unshift(_cartList[i])
				          }else{
				            _cart_list.push(_cartList[i])
				          }
				        }
         				that.cartList = _cart_list
						that.nullList =true
						
						this.checkCartList()
	      			})
	    },
	 handletouchstart(eve){
		
	 	// console.log("开始滑动",eve)
		this.startX = eve.targetTouches[0].clientX
		 
		// console.log(_startX )
	 },
	 handletouchmove(cartid){
		// alert(cartid)]
		if(cartid==this.moveCartId)return
		this.moveCartId = cartid
	 },
	 handletouchend(eve){

	 
		let endX = eve.changedTouches[0].clientX

		let _cartList = this.cartList
		// let indexof = 0
		
			if(this.moveCartId==0)return
		
		    if (this.startX - endX>30){
		      _cartList.forEach((item,index) => {
		          item.showDelete = false
		        if (item.id == this.moveCartId) {
		          item.showDelete = true
		        }
		      })

		        this.cartList= _cartList
		
		    } else if (this.startX - endX<-30){
		      _cartList.forEach((item) => {
		        if (item.id == this.moveCartId) {
		          item.showDelete = false
		        }
		      })
		        this.cartList= _cartList
		    }
			 _cartList.forEach((item,index)=>{
				  this.$set(this.cartList, index, item)
			 })
			
		event.stopPropagation();	
			
	 },
	// 点击删除
	  handleDelCart:function(cartid){
	    let that = this
	    let _cartList = this.cartList
	    _cartList.forEach((item,index) => {
	      if (item.id == cartid) {
	        item.del = true
			this.$set(this.cartList, index, item)
	      }
	    })
	   
	    setTimeout(() => {
	      _cartList.forEach((item,index) => {
	        if (item.id == cartid) {
	          item.nullShow = true
			  item.noSlect  =true
			  this.$set(this.cartList, index, item)
	        }
	      })
	      that.handleDelete(cartid)
	    },0)
	},
	// 删除橘袋
	  handleDelete: function (cartid) {
		
	    let that = this
	    let _cartList = this.cartList
		let indexOf 
		this.axios({
		            method: 'post',
		            url:"Allcart/delCart",
		            data:{
		               cart_ids: [cartid]
		            }
		          }).then(res=>{
	    
			that.computerSlect()
	      _cartList.forEach((item, index, array) => {
	        if (item.id == cartid) {
				indexOf = index
	          // array.splice(index, 1)
	        }
	      })
	      setTimeout(() => {
	        // this.cartList.splice(indexOf, 1)
	        // that.getNowChoseCart()
			
	      },500)
	    })
	    
	  },
	  // 获取已选中的橘袋
	    getNowChoseCart:function(){
	      let _cartList = this.cartList
	      let _choseCart = this.choseCart||[]
	      for (let i = 0; i < _cartList.length;i++){
	        for (let j = 0; j < _choseCart.length;j++){
	          if (_cartList[i].id == _choseCart[j]){
	            _cartList[i].slect = true
	          }
	        }
	      }
	      this.setData({
	        cartList: _cartList,
	        choseCart:[]
	      })
	  
	      this.checkCartList()
	    },
	 // 调整购物车详情
	toCartDetail(cartid){
		this.$router.push({
			name: 'cartDetail',
			params: { "cartid":cartid}
		});
	},
	handleslect(cartid){
	let _cartList = this.cartList
		let indexOfItem = 0
		let newValue = {}
		_cartList.forEach((item,index)=>{
			if(cartid==item.id){
				indexOfItem = index
				newValue =item
			
			}
		})
		this.cartList[indexOfItem].slect = !this.cartList[indexOfItem].slect;
		this.$set(this.cartList , indexOfItem , this.cartList[indexOfItem]);
		this.computerSlect()
	},
  // 全选
  allSlectHandle:function(){
    let _cartList = this.cartList
    if (_cartList.length==1){     //只有一个橘袋
        if (_cartList[0].source==0){    //且橘袋为自选橘袋
          if (_cartList[0].goods_info.length < 3 ){      //自选橘袋商品数量小于3
            wx.showModal({
              title: '营养师提示',
              content: '营养补充须全面，请选择3种以上补剂。',
              showCancel: false
            })
              return
          } else if (_cartList[0].goods_info.length > 8) {    //自选橘袋商品数量大于8
            wx.showModal({
              title: '营养师提示',
              content: '营养补充须循序渐进，请删减至不超过8种补剂。',
              showCancel: false
            })
              return
          }
        }
    }

    let _allSlect = !this.allSlect
    
    if (!_allSlect){
      console.log("全不选")
      _cartList.forEach((item) => {
          item.slect = false

      })
    }else{
      console.log("全选")
      _cartList.forEach((item) => {
      item.slect = true
      })
    }
    
      this.allSlect= _allSlect
      this.cartList= _cartList
    
    this.computerSlect()
  },

	// 检查标记所有不符合购买标准的橘袋
	  checkCartList: function(){
	    let _cartList = this.cartList
	      _cartList.forEach((item) => {
	        item.noSlect = false
	        if (item.source == 0) {    //自选橘袋
	    
	          if (item.goods_info.length < 3) {
	            item.noSlect = true
	            return
	          }
	          if (item.goods_info.length > 8) {
	            item.noSlect = true
	            return
	          }
	        } else if (item.source == 1) {     //报告创建橘袋
	          if (item.goods_info.length < item.product_num && item.goods_info.length < 3) {
	            item.noSlect = true
	            return
	          }
	          if (item.goods_info.length > 8) {
	            item.noSlect = true
	            return
	          }
	        }
	      })
	    
	      this.cartList =  _cartList
	   
	    this.computerSlect()
	  },
  // 计算所有选选中的橘袋
  computerSlect:function(){
    let _cartList = this.cartList
    let _allSlect = true
    let _totalPay = 0
    let _disPrice = 0
    let _noSlectNum = 0      //不能选中的橘袋数量等于橘袋数量,则取消全选
    _cartList.forEach((item) => {
      if (item.noSlect){
        item.slect =true
        _noSlectNum++
      }
      if(!item.slect){
        _allSlect = false
      }else{
        if (!item.noSlect){
          _totalPay += Number(item.totalPrice)
        }
        
      }
    })
    if (_noSlectNum == _cartList.length){
      _allSlect = false
    }
    _totalPay = this.base.changeNumber(_totalPay)
    this.allSlect= _allSlect
    this.totalPay= _totalPay
    this.disPrice= _disPrice
    
  },
  // to创建订单
  toCreateOrder:function(returnCartIds){
	  
    if (this.totalPay>5000){
   
		this.AlertShow = true
		this.alertMsg = "订单金额超出限额。根据海关总署、国家税务总局《关于跨境电子商务零售进口税收政策的通知》，自2019年1月1日起，个人单笔交易限值人民币5000元，个人年度交易限值人民币26000元。"
      return
    }
	if(returnCartIds.length<1){
		this.AlertShow = true
		this.alertMsg = "橘袋没有产品，请重新选择"
		this.allSlect = true
		this.allSlectHandle()
		this.getCartList()
		return
	}
    this.checkGoodsInfo()
   
  },
  // 检查商品信息是否能创建订单
  checkGoodsInfo: function (returnCartIds) {
    let that = this
    let cart_ids = ""
    let checkCartids=[]
    let _cartList = this.cartList
    _cartList.forEach((item) => {
      if (!item.noSlect) {     
          if(!item.del){      //是否被删除
              if (item.slect) {
                cart_ids += item.id + ","
                checkCartids.push(item.id)
              }
          }
        
      }
    })
    if (returnCartIds && returnCartIds.length>0){
      checkCartids = returnCartIds
      cart_ids=""
      returnCartIds.forEach((item)=>{
          cart_ids += item + ","
      })
    }
    this.axios({
                method: 'post',
                url:"Allcart/checkCart",
                data:{
                   member_id:this.$store.state.member_id,
				   cart_ids: checkCartids,
                }
        }).then(res=>{
			if (res.data.code == 0) {
			  alert(res.data.msg)
			  return
			}
			if (res.data.code == 3) {   //产品已下架或售罄
		   
				  that.selloutShow=true
			
				  that.selloutMsg = Object.assign({},{
						msg: res.data.msg,
						msgArr:res.data.msgArr,
						cart_ids: checkCartids,
						msgCode:3
				  })
			}
			if (res.data.code == 2) {   //产品正在预售中
			 that.selloutShow=true,
			 that.selloutMsg= Object.assign({},{
								msg: res.data.msg,
								msgArr:res.data.msgArr,
								cart_ids: checkCartids,
								msgCode:2
			 })
			}
			if (res.data.code == 1){
				this.toMadeOrderPage(checkCartids)
			}
		})
	},
	// 调整创建订单页面
	toMadeOrderPage(cartids,secondCheck){
		let _params = { "cartids":cartids}
		
		if(secondCheck){
			_params.secondCheck = true
		}
		console.log(_params)
	  this.$router.push({
						name: 'orderMade',
						params: _params
						});
	},
	
	// 父组件从缺货提示子组件获取值
	getMsgFormSellout(msg){
		this.selloutShow = msg
	},
	// 修改橘袋购买方案
	changePlan(cartid){
		console.log(cartid)
		this.$refs.edit.getCartDetail(cartid,4);
	},
	// 更改购买方案后更新购物车
	  updateCartList: function (cartid, payMoney, buyday, buyTitle, originalMoney,buyImg){
	    let _cartList = this.cartList
	      _cartList.forEach((item)=>{
	        if (item.id == cartid){
	          item.buy_days = buyday
	          item.totalPrice = payMoney
	          item.originalPrice = originalMoney
	          item.plan_title = buyTitle
	          item.img = buyImg
	        }
	      })
		this.cartList = _cartList
	    this.computerSlect()
	  },
	  // 输入套餐数量
	    changeMealNum:function(e){

	      let _num = Number(e.target.value)
	      if (_num < 1) {
	        _num = 1
	      }
	      if (_num > 99) {
	        _num = 99
	      }
	      this.$refs.edit.editCartNum(e.srcElement.dataset.cartid, _num).then((res)=>{
	        if(res.data.code==2){
				that.alertMsg = res.data.msg
				that.AlertShow = true
	          return
	        }
	        this.changeCartNum(e.srcElement.dataset.cartid, _num)
	      })
	      
	    },
	// 减少套餐数
	  cutMealNum:function(cartid,num){
	    if (num>1){
	      let _num = num -1
	      this.$refs.edit.editCartNum(cartid, _num).then((res) => {
	        if (res.data.code == 2) {
	          that.alertMsg = res.data.msg
	          that.AlertShow = true
	          return
	        }
	        this.changeCartNum(cartid, _num)
	      })
	    }
	    
	  },
	  // 增加套餐数
	  addMealNum:function(cartid,num){
	    if (num < 99) {
	      let _num = Number(num) + 1
	      this.$refs.edit.editCartNum(cartid, _num).then((res) => {
	        if (res.data.code == 2) {
	          that.alertMsg = res.data.msg
	          that.AlertShow = true
	          return
	        }
	        this.changeCartNum(cartid, _num)
	      })
	    }
	  },
	  // 调整购物橘袋数量
	  changeCartNum:function(cartid,num){
	    let _cartList = this.cartList
	    _cartList.forEach((item)=>{
	      if (item.id == cartid){
	        item.num = num
	        item.totalPrice = Number(item.total_price)*Number(num)
	        item.originalPrice = Number(item.original_price)* Number(num)
	      }
	    })
	    this.cartList= _cartList
	    this.computerSlect()
	  },
	  // 关闭提示
	  closeAlertShow(){
		  this.AlertShow = false
	  },
	  // 取消删除缺货
	  cancelCreateOrder(){
		  
	  },
    // 做问卷
   toQuestions(){
    this.$router.push({name: 'beforeQuestion'});
   },
  }
}
</script>
<style>
#cart{
  background:rgba(244,242,240,1);
  width: 7.5rem;
  height: 100vh;
  position:relative;
  margin: 0 auto;
  overflow-y:auto;
}
#cart::-webkit-scrollbar {display:none}
.cart .title span{
  position: relative;
}
.cart .title text::after {
    position: absolute;
    content: "";
    left: 0;
    right: 0;
    bottom: -20rpx;
    height: 10rpx;
    background: #C25E4D;
    border-radius: 10rpx;

}
.cart .text {
    padding-bottom: 20rpx;
    margin-bottom: 30rpx;
    color: #505050;
    font-size: 28rpx;
    border-bottom: 1px solid #F2F4F8;
}
.cart .attrs {
    padding: 20rpx 0 44rpx 0;
    display: flex;
    justify-content: center;
}
.cart .attrs .item {
    padding: 10rpx 60rpx;
    flex: 1;
    border-right: 1px solid #F2F4F8;
}
.cart .attrs .item:last-child {
    border: none;
}
.cart .attrs .item div:first-child {
    color: #333;
    font-weight: bold;
    font-size: 34rpx;
    margin-bottom: 10rpx;
}
.cart .attrs .item div:last-child {
    font-size: 24rpx;
    color: #9B9B9B;
}
.cart .app-btn {
  
    margin-bottom: 50rpx;
    height: 100rpx;
    line-height: 100rpx;
}




.select-time {
    width: 100%;
    box-sizing: border-box;
    min-height: 600rpx;
    background: #fff;
    position: fixed;
    bottom: -800rpx;
    left: 0;
    padding: 30rpx;
    z-index: 11;
    overflow:visible;
    transition: all .3s;
}
.outShow{
  bottom: 0;
}
.select-time .close {
    position: absolute;
    right: 40rpx;
    top: 40rpx;
    z-index: 90;
}
.select-time .close img {
    width: 25rpx;
    height: 25rpx;
}
.select-time .product {
    display: flex;
    position: relative;
    top: -80rpx;
}
.select-time .product .thumb {
    width: 169rpx;
    height: 169rpx;
    flex-shrink: 0;
    position: relative;
}
.select-time .product .thumb:after {
    position: absolute;
    content: '';
    left: -15rpx;
    top: 20rpx;
    width: 100%;
    height: 100%;
    background:rgba(156,174,216,1);
    border-radius:14px;
    opacity:0.5025;
    filter:blur(15px);
    z-index: -1;
}
.select-time .product .thumb image {
    width: 100%;
    height: 100%;
    border-radius: 10rpx;
}
.select-time .product .info {
    padding-left: 35rpx;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}
.select-time .product .info .name {
    font-size: 32rpx;
    font-weight: bold;
    padding: 10rpx 0;
}
.select-time .product .info .price {
    color: #C25E4D;
    font-weight: bold;
}
.select-time .select {
    padding: 0 20rpx;
}
.select-time .select .title {
    color: #727171;
}
.select-time .select .items {
    padding: 20rpx 0 35rpx 0;
    display: flex;
    flex-wrap:wrap;
}
.select-time .select .items2 {
    padding: 20rpx 0 35rpx 0;
    display: flex;
    flex-wrap:wrap;
}
.select-time .select .item {
    padding: 12rpx 30rpx;
    background: #fff;
    border: 1rpx solid rgba(114, 113, 113, 0.8);
    border-radius: 5rpx;
    margin-right: 15rpx;
    font-size: 24rpx;
    margin-bottom: 10rpx;
}
.nullpick{
   background:  #ddd  !important;
   border: 1rpx solid #ddd  !important;
   color: #fff !important;
}
.select-time .select .item.active {
    background: rgba(194, 95, 77, 0.281);
    border-color: #C25E4D;
}
.select-time .select .tip {
    color: #999;
}
.select-time .btns {
    padding: 50rpx 0 20rpx 0;
    text-align: center;
}
#yuyuexiadan{
 width:220rpx;
}

.productBox{
  height: 266rpx;
  transition: all 0.5s;
}
.productNull{
  height: 0 !important;
}


.notLoginBox{
  width: 100vw;
  position: fixed;
  left: 50%; top: 50%;   
  transform: translate(-50%, -50%); 
  z-index: 999;
}
.notLoginPage{
width: 100vw;
height: 100vh;
position: fixed;
top:0;
left: 0;
background-color: #fff;
z-index: 100
}
.notLoginImg{
  width: 509rpx;
  height: 277rpx;
  margin: 0rpx 120rpx 40rpx;
}
.notLoginImg image{
   width: 509rpx;
  height: 277rpx;
}
.notLoginImgTxt{
  height:40rpx;
  font-size:28rpx;
  font-family:PingFangSC;
  font-weight:300;
  color:rgba(68,68,68,1);
  line-height:40rpx;
  text-align: center;
  margin-bottom: 60rpx;
}
.notLoginImgBtn{
  display: flex;
  justify-content: center;
}

.noGoodsPage{
  width:670rpx;
  height:551rpx;
  background:rgba(255,255,255,1);
  box-shadow:0rpx 0rpx 20rpx 0rpx rgba(220,207,191,0.6);
  border-radius:10rpx;
  position: fixed;
  top:50%;
  left:50%; 
  transform: translate(-50%, -50%);
}
.noGoodsPageName{
  text-align: center;
  font-size:48rpx;
  font-family:SourceHanSansCN-Medium,SourceHanSansCN;
  font-weight:500;
  color:rgba(20,20,20,1);
  line-height:72rpx;
  padding-top: 75rpx;
}
.noGoodsPageTitle{
  font-size:28rpx;
  font-family:PingFangSC-Light,PingFang SC;
  font-weight:300;
  color:rgba(80,80,80,1);
  line-height:44rpx;
  padding: 20rpx 0;
  text-align: center;
}
.noGoodsPageBtnBox{
  text-align: center;
}
.noGoodsPageBtnBox button{
  margin-top:36rpx;
}


.cartListBox{
  width:6.7rem;
  height:2.8rem;
  background:rgba(255,255,255,1);
  box-shadow:0 0 0.4rem 0 rgba(220,207,191,0.6);
  border-radius:0.1rem;
  margin: 0.2rem auto;
  position: relative;
  display: flex;
  left: 0;
  top: 0;
  transition: all 0.15s;
  overflow: hidden;
}
.cartDel{
  left: -2.1rem;
  overflow: visible;
}
.cartListdelBtn{
  position: absolute;
  top: 0;
  right:-2.3rem;
  width: 1.9rem;
  height: 2.77rem;
  line-height: 0.3rem;
  font-size:0.3rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(255,255,255,1);
  text-align: center;
  padding: 1.23rem 0;
  box-sizing: border-box;
  border-radius:0.05rem;
  background:#C25E4D;
}
.cartListdelBtn img{
  width: 0.32rem;
  height: 0.3rem;
  position: relative;
  top:0.05rem;
  margin-right:0.05rem;
}
.selecting{
  width:0.35rem;
  height:0.35rem;
  border-radius: 0.35rem;
  border:0.02rem solid rgba(196,196,196,1);
}
.noselecting{
  width:0.35rem;
  height:0.35rem;
  border-radius: 0.35rem;
  /* border:2rpx solid rgba(196,196,196,1); */
  position: absolute;
  top:50%;
  left:50%; 
  transform: translate(-50%, -50%);
}
.selected{
  width:0.39rem;
  height:0.39rem;
  border-radius: 0.39rem;
  overflow: hidden;
}
.selected img{
  width:0.39rem;
  height:0.39rem;
  display: block;
}

.cartListBoxLeft{
  padding: 0.18rem;
  position: absolute;
  right: 0;
  top:0;
}
.cartListBoxMid{
  width: 1.88rem;
  padding-top:0.46rem;
  position: relative;
  margin-left: 0.34rem;
}
.cartListBoxMid img{
  width: 1.88rem;
  height:1.88rem;
  border-radius: 0.1rem;
}
.cartListBoxRight{
  flex: 1;
  padding-left: 0.3rem;
  padding-top: 0.46rem;
  text-align: left;
}
.cartListBoxLab{
  position: absolute;
  top:0.46rem;
  left: 0;
  min-width: 0.1rem;
  padding: 0 0.15rem;
  height:0.36rem;
  background-color: #CCB697;
  font-size:0.2rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:0.36rem;
  text-align: center;
  border-radius:0.1rem 0;
}
.cartListBoxName{
  font-size:0.32rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(20,20,20,1);
  line-height:0.45rem;
  width: 3.8rem;
  overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
  padding-bottom: 0.24rem;
}
.cartListBoxPlan{
  min-width:1rem;
  height:0.44rem;
  border:0.02rem solid rgba(153,153,153,1);
  border-radius:0.44rem;
  text-align: center;
  font-size:0.26rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(20, 20, 20, 1);
  line-height: 0.44rem;
  position: relative;
  display: inline-block;
  padding: 0 0.2rem;
}
.cartListBoxPlan img{
  width: 0.18rem;
  height: 0.11rem;
  position: relative;
  top:-0.06rem;
  margin-left: 0.15rem;
}
.cartListBoxPlan2{
  height:0.39rem;
  display: flex;
font-size:0.26rem;
}
.mealBtn{
  width:0.46rem;
  height:0.46rem;
  position: relative;
}

.mealBtn img{
  display: block;
  width:0.44rem;
  height:0.44rem;
}

.mealNumBox{
  padding: 0 0.1rem;
   width: 0.62rem;
   height:0.44rem;
   line-height: 0.44rem;
  display: flex;
  font-size:0.26rem;
}
.mealNumBox input{
  height:0.44rem;
  line-height: 0.44rem;
  width: 0.6rem;
  padding: 0;
  margin: 0;
  text-align: center;
  font-size:0.3rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(20,20,20,1);
  letter-spacing:0.01rem;
  border:0;
}


.cartListBoxPrice{
  height:0.45rem;
  font-size:0.2rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:0.45rem;
  margin-bottom: 0.22rem;
}
.cartListBoxNowPrice{
  font-size:0.32rem;
  font-weight:500;
  margin-right: 0.14rem;
}
.cartListBoxBeforePrice{
  font-size:0.2rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(137,137,137,1);
  text-decoration: line-through;
}
.cartListBoxPlanBtn{
  position: absolute;
  bottom: 0.5rem;
  right: 0.24rem;
  width:1.2rem;
  height:0.38rem;
  font-size:0.24rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(194,94,77,1);
  line-height:0.33rem;
  display: flex;
  
}
.cartListBoxPlanBtn img{
	position: relative;
	top:0.08rem;
  width:0.1rem;
  height:0.18rem;
  margin-left: 0.1rem;
  
}
.cartListTxt{
  height:0.3rem;
  font-size:0.2rem;
  font-family:PingFangSC-Light,PingFang SC;
  font-weight:300;
  color:rgba(137,137,137,1);
  line-height:0.28rem;
  text-align: center;
  padding:0.4rem;
}
.allCheck{
  position: relative;
  width: 1.1rem;
  display: flex;
  justify-content: space-between;
  align-items:center;
}
.allChecked{
  width:0.38rem;
  height:0.38rem;
  border-radius: 0.38rem;
  box-sizing: border-box;
  /* border:2rpx solid rgba(196,196,196,1); */
  margin-right: 0.14rem;
}
.allChecked img{
  width:0.38rem;
  height:0.38rem;
}
.allChecking{
  width:0.38rem;
  height:0.38rem;
  border-radius: 0.38rem;
  border:0.02rem solid rgba(196,196,196,1);
  box-sizing: border-box;
}


.cartListBoxDel{
  visibility: hidden;
}
.nullBox{
  height: 3.17rem;
  transition: all 0.2s;
}
.nullBox2{
  height: 0;
}
.lab0{
  background: #A8B59F;
}
.lab2{
  background: #A3B1BF;
}



.orderbarpad {
    height: 0.2rem;
}
.orderbar {
    position: fixed;
    width: 7.5rem;
    left: 50%;
    transform: translate(-50%, 0); 
    right: 0;
    bottom: 1.1rem;
    padding: 0.4rem;
    background: #fff;
    box-shadow: 0px -6px 20px 0px rgba(0,0,0,0.08);
    display: flex;
    justify-content: space-between;
    z-index:2;
}
.orderbar .payBtn{
	position: relative;
	background-color: #C25E4D;
	color: #fff;
	border-radius: 1rem;
	display: inline-block;
	width:2.2rem;
	line-height: 0.88rem;
	font-size: 0.3rem;
	overflow: visible;
	font-weight: 500;
	margin: 0;
	text-align: center;
	letter-spacing: 0.005rem;

}

.orderbar .total {
    text-align: right;
    flex: 1;
    margin-right:0.4rem;
}
.orderbar .total div:first-child {
    font-weight: bold;
    font-size: 0.3rem;
    
}

.orderbar .total div:last-child {
    font-size: 0.28rem;
    color: #9B9B9B;
}
.orderbar .app-btn {
    width: 3.8rem;
}

.noCart {
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgba(220,207,191,0.6);
    border-radius: 0.1rem;
    position: relative;
    text-align: center;
	width:5.5rem;
	box-sizing: border-box;
    padding: 0.4rem;
    margin: 3rem auto;
}

.noCartTitle{
    font-size: 0.42rem;
    font-weight: bold;
    padding: 0.3rem 0;
}
.noCartMsg {
	font-size: 0.24rem;
    color: #505050;
	margin-bottom:0.5rem;
}

#cart .outShow{
	bottom: 1.1rem;
}
	
</style>